// const AccountProfilePage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountProfilePage')
import routesModerator from '@/router/routesModerator'
import routesPartner from '@/router/routesPartner'
import routesAgent from '@/router/routesAgent'
import routesEmployer from '@/router/routesEmployer'

const AccountProfileCompanyPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountProfileCompanyPage')
const RecommendedVacanciesPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/RecommendedVacanciesPage')
const AccountNewVacancyPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountNewVacancyPage')
const AccountVacancyEditPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountVacancyEditPage')
// const AccountResumeEdit = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumeEditPage')
// const AccountReceivedResumes = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountReceivedResumes') // deprecated
const AccountRegisterCandidate = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountRegisterCandidate')
const AccountReceivedOffers = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountReceivedOffers')
const AccountResumeCardPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumeCardPage')
const AccountCooperationPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountCooperationPage')
// const AccountNewResumePage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountNewResumePage')
// const AccountResumePage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumePage')
const AccountMailingPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountMailingPage')
const AccountHelpPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountHelpPage')
const AccountSettingsPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountSettingsPage')
const AccountInteractionPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountInteractionPage')
// const AccountResumeViewPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumeViewPage')
const AccountMyVacanciesPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountMyVacanciesPage')
const AccountBalancePage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountBalancePage')
const AccountBalancePage_old = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountBalancePage_old')
const AccountResumeListPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumeListPage')
const AccountStatisticPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountStatisticPage')
const AccountEmployeesPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountEmployeesPage')
const UsefulMaterialsPage = () => import(/* webpackChunkName: "news-page" */ '../views/UsefulMaterialsPage')
const AccountDashboardPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountDashboardPage')
const AccountVacanciesResponses = () => import(/* webpackChunkName: "account-page" */ '../views/Account/employer/AccountVacanciesResponses')
const NewsSinglePage = () => import(/* webpackChunkName: "news-page" */ '@/views/NewsSinglePage')
import {EMPLOYER, EMPLOYEE, PARTNER, MODERATOR, AGENT} from '@/constants/usersTypes'
import store from '@/store'

export default [{
  path: '',
  redirect: () => {
    const userType = store.state.user.profile.user_type

    if (userType === EMPLOYEE) return 'resumes'
    if (userType === EMPLOYER) return 'vacancies'
    if (userType === PARTNER) return 'partners'
    if (userType === MODERATOR) return 'moderator'
    if (userType === AGENT) return 'partner'

    return 'home'
  },
// }, {
//   path: 'profile',
//   name: 'account-profile',
//   component: AccountProfilePage,
}, {
  path: 'employer-profile',
  name: 'account-employer-profile',
  component: AccountProfileCompanyPage,
// }, {
//   path: 'resumes',
//   name: 'account-resumes',
//   component: AccountResumePage,
//   meta: {
//     requiredUserTypes: [EMPLOYEE, PARTNER]
//   }
}, {
  path: 'register-candidate',
  name: 'account-register-candidate',
  component: AccountRegisterCandidate,
}, {
//   path: 'view-resume',
//   name: 'account-view-resume',
//   component: AccountResumeViewPage,
//   meta: {
//     requiredUserTypes: [EMPLOYER]
//   }
// }, {
  path: 'my-resume',
  name: 'account-my-resume',
  component: AccountResumeCardPage,
  meta: {
    requiredUserTypes: [EMPLOYEE]
  }
// }, {
//   path: 'resumes/:resumeId',
//   name: 'account-edit-resume',
//   component: AccountResumeEdit,
//   meta: {
//     requiredUserTypes: [EMPLOYEE, PARTNER]
//   }
}, {
//   path: 'resumes-old/new',
//   name: 'account-new-resume-old',
//   component: AccountNewResumePage,
//   meta: {
//     requiredUserTypes: [EMPLOYEE, PARTNER]
//   }
// }, {
//   path: 'resumes-old/:resumeId',
//   name: 'account-edit-resume-old',
//   component: AccountNewResumePage,
//   meta: {
//     requiredUserTypes: [EMPLOYEE, PARTNER]
//   }
// }, {
  path: 'received-resume/:resumeId',
  name: 'received-resume',
  component: AccountResumeCardPage,
  meta: {
    requiredUserTypes: [EMPLOYER, PARTNER, AGENT]
  }
}, {
  path: 'recommended-vacancies',
  name: 'account-recommended-vacancies',
  component: RecommendedVacanciesPage,
  meta: {
    requiredUserTypes: [EMPLOYEE, PARTNER]
  }
}, {
  path: 'account-mailing',
  name: 'account-mailing',
  component: AccountMailingPage,
  meta: {
    requiredUserTypes: [EMPLOYEE, PARTNER, AGENT]
  }
}, {
  path: 'cooperation/:interactionId',
  name: 'account-cooperation-interaction',
  component: AccountCooperationPage
}, {
  path: 'cooperation',
  name: 'account-cooperation',
  component: AccountCooperationPage
}, {
  path: 'my-vacancies',
  name: 'account-my-vacancies',
  component: AccountMyVacanciesPage,
  meta: {
    requiredUserTypes: [EMPLOYEE, PARTNER]
  }
}, {
  path: 'resume-list',
  name: 'account-resume-list',
  component: AccountResumeListPage,
}, {
  path: 'vacancies/new-vacancy',
  name: 'account-new-vacancy',
  component: AccountVacancyEditPage,
  meta: {
    requiredUserTypes: [EMPLOYER]
  }
}, {
  path: 'vacancies/new-vacancy-old',
  name: 'account-new-vacancy-old',
  component: AccountNewVacancyPage,
  meta: {
    requiredUserTypes: [EMPLOYER]
  }
}, {
  path: 'vacancies/edit/:vacancyId',
  name: 'account-edit-vacancy',
  component: AccountNewVacancyPage,
  meta: {
    requiredUserTypes: [EMPLOYER]
  }
}, {
  path: 'received-offers',
  name: 'account-received-offers',
  component: AccountReceivedOffers,
  meta: {
    requiredUserTypes: [EMPLOYEE, PARTNER]
  }
}, {
  path: 'help',
  name: 'help',
  component: AccountHelpPage
}, {
  path: 'settings',
  name: 'account-settings',
  component: AccountSettingsPage,
  meta: {
    requiredUserTypes: [EMPLOYEE, AGENT]
  }
}, {
  path: 'interaction/:id',
  name: 'account-interaction',
  component: AccountInteractionPage
}, {
  path: 'balance/:tab?',
  name: 'account-balance',
  component: AccountBalancePage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'balance-old',
  name: 'account-balance-old',
  component: AccountBalancePage_old,
  meta: {
    requiredUserTypes: [PARTNER]
  }
}, {
  path: 'statistic',
  name: 'account-statistic',
  component: AccountStatisticPage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'employees',
  name: 'account-employees',
  component: AccountEmployeesPage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'useful-materials',
  name: 'account-useful-materials',
  component: UsefulMaterialsPage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'useful-materials/:newsSlug',
  name: 'useful-materials-single',
  component: NewsSinglePage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'dashboard',
  name: 'account-dashboard',
  component: AccountDashboardPage,
  meta: {
    requiredUserTypes: [PARTNER, AGENT]
  }
}, {
  path: 'vacancies-responses',
  name: 'account-vacancies-responses',
  component: AccountVacanciesResponses,
  meta: {
    requiredUserTypes: [EMPLOYER, PARTNER, AGENT]
  }
},
  ...routesModerator,

  ...routesPartner,

  ...routesAgent,

  ...routesEmployer,
]
